module.exports = __webpack_public_path__ + "static/media/linkCard_incentives_hover.d0d4cae2.svg";